import { useEffect, useState } from 'react';

import useSWR from 'swr';

import { usePrivate } from '@/components/private/PrivateContext';
import { enqueueSnackbar } from '@/providers/SnackbarProvider';
import { OrganisationSettingTypeCode } from '@/apiClient';
import { hookMessages } from './messages';

export function useFetchOrganisationConfig(
  organisationId: number | null | undefined,
  organisationSettingTypeCode: OrganisationSettingTypeCode,
) {
  const { organisationSettingApi } = usePrivate();

  const [mailtoAddress, setMailtoAddress] =
    useState<string>('office@abri.com.au');
  const [facebookAppId, setFacebookAppId] = useState<string>('');

  const {
    data: organisationSettingResponse,
    isLoading,
    isValidating,
  } = useSWR(
    organisationSettingApi && organisationId
      ? `/api/OrganisationSetting/${organisationId}`
      : null,
    () => organisationSettingApi?.apiOrganisationSettingGet(organisationId!),
    {
      onError: (error) => {
        enqueueSnackbar(
          hookMessages['hooks.organisationSettingsApi.fetchError'],
          {
            variant: 'error',
          },
        );
        console.error('[BreedLogic] organisation setting api error:', error);
      },
    },
  );

  useEffect(() => {
    if (organisationSettingResponse?.data) {
      const data = organisationSettingResponse.data.find(
        (d) => d.settingTypeCode === organisationSettingTypeCode,
      )?.value;

      if (data) {
        switch (organisationSettingTypeCode) {
          case OrganisationSettingTypeCode.MailToAddress:
            setMailtoAddress(data);
            break;
          case OrganisationSettingTypeCode.FacebookPageLink:
            setFacebookAppId(data);
            break;
        }
      }
    }
  }, [organisationSettingResponse, organisationSettingTypeCode]);

  return { mailtoAddress, facebookAppId, isLoading, isValidating };
}
